/* eslint-disable node/no-unsupported-features */
export default {
    locale: 'en',
    title: 'Application & Data Management',
    tool: 'Telomere tool',
    home: 'Home',
    about: 'About',
    blog: 'Blog',
    feed: 'Tweets',
    contact: 'Contact us',
    notFound: 'page not found',
    offlineTitle: 'Offline',
    offline: 'no internet connection',
    italian: 'Italian',
    english: 'English',
    theme: 'Dark Theme',
    privacy: 'privacy',
    terms: 'for internal use only',
    username: 'username',
    password: 'password',
    login: 'Login',
    messagelogin: 'Insert User and Password',
    errorlogin: 'Wrong credentials',
    notAllowed: 'operation not allowed',
    errcalcTelomere: 'error in telomere calculation',
    loginExpired: 'login expired',
    logout: 'Logout',
    age: 'age',
    sex: 'sex',
    male: 'male',
    female: 'female',
    length: 'telomere kilobase',
    calculate: 'Calculate',
    errorTelomereAge: 'Age must be between 0 and 150',
    errorTelomereLength: 'Length must be more than 0 and less than 10',
    errorTelomere: 'Wrong data',
    top20Algo: 'biological age top20',
    mediaAlgo: 'biological age media',
    bottom20Algo: 'biological age bottom20',
    averageLengthForAge: 'average length for age',
    bruteForceAlgo: 'biological age g',
    top20AlgoEXP: 'biological age top20 exp',
    mediaAlgoEXP: 'biological age media exp',
    bottom20AlgoEXP: 'biological age bottom20 exp',
    algorithmG: 'g algorithm',
    algorithmLab: 'lab algorithm',
    algorithmExp: 'log algorithm',
    telomereMLAge: 'ML algorithm',
    suggestedAge: 'suggested age',
    baseData: 'base data',
    lengthMean: 'average length',
    telomereMLLength: 'ML Length',
    ageMean: 'average age',
    lengthDeviation: 'standard deviation',
    lengthDeviationWarning: 'standard deviation warning',
};



// WEBPACK FOOTER //
// ./src/constants/locale-en.js